module.exports = __webpack_public_path__ + "media/images/event_symbolic-a5651963accc1b3f1967593aebbf5bb6.jpg";